import styled from 'styled-components/native';

export const Container = styled.View`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.color.base.c1};
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.base.c3};
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.medium};
`;

export const Title = styled.Text`
  font-family: ${({ theme }) => theme.fontFamily.core.w600};
  color: ${({ theme }) => theme.color.base.c9};
  font-size: ${({ theme }) => theme.fontSize.body2};
  line-height: 20px;
`;

export const Body = styled.Text`
  margin-top: 2px;
  font-family: ${({ theme }) => theme.fontFamily.core.w400};
  color: ${({ theme }) => theme.color.base.c6};
  font-size: ${({ theme }) => theme.fontSize.footnote};
  line-height: 18px;
`;
